import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { colors } from '@mm/utils';
import classnames from 'classnames';
import css from './ModalCloseButton.module.css';

export interface IModalCloseButton {
  color?: string;
  className?: string;
  onClick?: () => void;
}

export const ModalCloseButton: React.FC<IModalCloseButton> = ({
  color,
  className,
  ...props
}) => {
  return (
    <CloseOutlined
      className={classnames(css.container, className)}
      color={color || colors.gray9}
      {...props}
    />
  );
};
